import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { ArrowButton } from "../components/Buttons";
import { CLIENTS } from "../data/site";

const Clients = () => (
  <div data-testid="clients-page">
    <PageHeader
      label="Clients & Collaborations"
      lines={["Built together."]}
      intro="Great work is built through great partnerships. We value every collaboration and believe the strongest results come from combining our creative perspective with our clients' vision."
    />

    <section className="bg-cream pb-24 md:pb-32">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        {/* Logos always visible — real client brand marks, subtle hover only */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-dark-text/10 border border-dark-text/10">
          {CLIENTS.map((client, i) => (
            <Reveal key={client.name} delay={(i % 4) * 0.05}>
              <div
                data-testid={`client-logo-${i}`}
                title={client.name}
                className="bg-white h-32 md:h-40 flex items-center justify-center p-7 md:p-9 group"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  loading="lazy"
                  className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-[1.06]"
                  draggable="false"
                />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-14">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-dark-text/45">
            A selection of brands we've collaborated with
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-16 md:mt-24 grid md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-8">
            <span className="label text-dark-text/50">Become a partner</span>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-dark-text mt-5 leading-tight">
              We'd love to add your brand to this list.
            </h2>
          </div>
          <div className="md:col-span-4 md:text-right">
            <ArrowButton to="/contact" testid="clients-work-together">Let's Work Together</ArrowButton>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Clients;
